module.exports = __webpack_public_path__ + "img/DS1823xs+.dcd33169.png";